module.exports = __webpack_public_path__ + "static/media/monitor.74e17aaa.svg";